import React, { Component } from 'react';

import { Table, Popconfirm } from 'antd';

class ServicesTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Název',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    sorter: (a, b) => a.name - b.name,
  }, {
    title: 'Hostname',
    dataIndex: 'host',
    key: 'host',
    sorter: (a, b) => a.host - b.host,
  }, {
    title: 'Port',
    dataIndex: 'port',
    key: 'port',
    sorter: (a, b) => a.port - b.port,
  }, {
    title: 'Instalováno',
    dataIndex: 'installed',
    key: 'installed',
    sorter: (a, b) => a.installed - b.installed,
    render: (text, record) => {
      return text ? 'Ano' : 'Ne';
    }
  }]

  render() {    
    return (    
      <Table         
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns} 
        dataSource={this.props.data} 
        style={{border: '0px'}} />
    );
  }
}

export default ServicesTable;


// WEBPACK FOOTER //
// ./src/components/ServiceTable.js